module.exports = {"331023001":"赤城街道","331023002":"始丰街道","331023003":"福溪街道","331023101":"白鹤镇","331023102":"石梁镇","331023104":"街头镇","331023105":"平桥镇","331023106":"坦头镇","331023107":"三合镇","331023108":"洪畴镇","331023200":"三州乡","331023203":"龙溪乡","331023204":"雷峰乡","331023207":"南屏乡","331023209":"泳溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331023.json
// module id = 942
// module chunks = 0